import HallDepositModal from "./hall-deposit-modal";

export default HallDepositModal;
